import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export const Logo = () => {
  return (
    <Link className="logo" to="/" rel="home">
      <StaticImage
        src="../../../static/assets/logo.png"
        alt="logo"
        placeholder="none"
      />
    </Link>
  )
}
